export const FETCH_PRINCIPALS_BY_IDS = "domain/fetchPrincipalsByIds";
export const SEARCH_PRINCIPALS = "domain/searchPrincipals";
